import axios, { buildApi } from '@/libs/api.request';
let name = ''

export const apis = buildApi({
  get: ['/shipments/export/statusList&list',],
  post: ['/shipments/export/statusExport']
})

export const awsFist = (airwayNumber) => {
  return axios.request({
    url: `/api/v1/tracker/awsPoint?awbno=${airwayNumber}`,
    method: 'get',
  })
}
